import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
function Toggle({
  checked,
  onChange
}: {
  checked: boolean;
  onChange: () => void;
}) {
  return <label className="relative inline-flex items-center cursor-pointer" data-id="element-592">
      <input type="checkbox" className="sr-only peer" checked={checked} onChange={onChange} data-id="element-593" />
      <div className="w-11 h-6 bg-surface2 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-594" />
    </label>;
}
export function SettingsNotifications() {
  const navigate = useNavigate();
  const [prefs, setPrefs] = useState({
    likes: true,
    comments: true,
    followers: true,
    mentions: true,
    approvals: false,
    trending: true,
    emailDigest: false,
    emailMarketing: false
  });
  const togglePref = (key: keyof typeof prefs) => setPrefs(p => ({
    ...p,
    [key]: !p[key]
  }));
  const pushItems: Array<{
    key: keyof typeof prefs;
    label: string;
  }> = [{
    key: 'likes',
    label: 'Likes'
  }, {
    key: 'comments',
    label: 'Comments'
  }, {
    key: 'followers',
    label: 'New followers'
  }, {
    key: 'mentions',
    label: 'Mentions'
  }, {
    key: 'approvals',
    label: 'Video approvals'
  }, {
    key: 'trending',
    label: 'Trending alerts'
  }];
  const emailItems: Array<{
    key: keyof typeof prefs;
    label: string;
  }> = [{
    key: 'emailDigest',
    label: 'Weekly digest'
  }, {
    key: 'emailMarketing',
    label: 'Tips & promotions'
  }];
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-595">
      <div className="px-4 py-4 flex items-center border-b border-border sticky top-0 bg-black z-10" data-id="element-596">
        <button onClick={() => navigate(-1)} className="text-white mr-4" data-id="element-597">
          <ArrowLeftIcon size={24} data-id="element-598" />
        </button>
        <h1 className="text-white font-poppins font-bold text-lg" data-id="element-599">
          Notifications
        </h1>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar pb-8" data-id="element-600">
        <h2 className="px-4 text-softGray text-xs font-bold uppercase tracking-wider mb-2 mt-6" data-id="element-601">
          Push
        </h2>
        <div className="bg-surface border-y border-border" data-id="element-602">
          {pushItems.map((item, i) => <div key={item.key} className={`px-4 py-4 flex items-center justify-between ${i !== pushItems.length - 1 ? 'border-b border-border' : ''}`} data-id="element-603">
              <span className="text-white text-sm font-medium" data-id="element-604">
                {item.label}
              </span>
              <Toggle checked={prefs[item.key]} onChange={() => togglePref(item.key)} data-id="element-605" />
            </div>)}
        </div>

        <h2 className="px-4 text-softGray text-xs font-bold uppercase tracking-wider mb-2 mt-6" data-id="element-606">
          Email
        </h2>
        <div className="bg-surface border-y border-border" data-id="element-607">
          {emailItems.map((item, i) => <div key={item.key} className={`px-4 py-4 flex items-center justify-between ${i !== emailItems.length - 1 ? 'border-b border-border' : ''}`} data-id="element-608">
              <span className="text-white text-sm font-medium" data-id="element-609">
                {item.label}
              </span>
              <Toggle checked={prefs[item.key]} onChange={() => togglePref(item.key)} data-id="element-610" />
            </div>)}
        </div>
      </div>
    </div>;
}